import { LinkQuery } from '@queries/Link';
import { BlockQuery, DatoAssetQuery } from '@queries/datoCMS';
import { gql } from 'graphql-request';
import { z } from 'zod';

export const HeroBlockQuery = new BlockQuery(
	'hero',
	gql`
		... on HeroRecord {
			_modelApiKey
			headline
			description
			subHeader
			subDescription
			media {
				${DatoAssetQuery}
			}
			link{
				${LinkQuery}
			}
		}
	`,
	z.object({
		_modelApiKey: z.enum(['hero']),
		headline: z.string(),
		description: z.string(),
		subHeader: z.string(),
		subDescription: z.string(),
		link: LinkQuery.validation.nullish(),
		media: z.array(DatoAssetQuery.validation)
	})
);

export type HeroBlock = z.infer<typeof HeroBlockQuery.validation>;
